import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_generic_doc_approval_conversion_monitor_RowClass} from '../../../dbschema';

export class GenericDocApprovalCoversionMonitorContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_approval_conversion_monitor: bl_fi_generic_doc_approval_conversion_monitor_RowClass = new bl_fi_generic_doc_approval_conversion_monitor_RowClass();
}
